import React from 'react';
import PropTypes from 'prop-types';
import CalendarUtils from 'services/CalendarUtils';
import ListBadge from 'components/Common/ListBadge';

const dateFormat = 'Do MMM YYYY';

const FaxBadge = ({ item }) => (
  <ListBadge
    title={item.title}
    firstLine={<FaxInfo item={item} />}
    secondLine={CalendarUtils.format(item.date, dateFormat)}
  />
);

const FaxInfo = ({ item }) => (
  <div>
    <span>
      {item.to} ({item.status})
    </span>
  </div>
);

FaxBadge.propTypes = {
  item: PropTypes.object.isRequired
};

export default React.memo(FaxBadge);
